import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CpaGridBridgeComponent } from './cpa-grid-bridge/cpa-grid-bridge.component';

@NgModule({
  declarations: [CpaGridBridgeComponent],
  imports: [CommonModule],
  exports: [CpaGridBridgeComponent]
})
export class UtilsComponentesModule {}
